import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Power = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Power" {...props}>
    <path d="M6.5 2.63379C6.97831 2.3577 7.5901 2.5217 7.86621 3C8.14215 3.47828 7.97824 4.09014 7.5 4.36621C4.90773 5.86271 3.00013 8.78732 3 12C3.00013 17.0437 7.02021 21 12 21C16.9798 21 20.9999 17.0437 21 12C20.9999 8.78742 19.0923 5.86276 16.5 4.36621C16.0218 4.0901 15.8578 3.47824 16.1338 3C16.3928 2.55162 16.9469 2.3799 17.4092 2.58789L17.5 2.63477L17.793 2.80957C20.7956 4.67556 22.9999 8.13086 23 12C22.9999 18.1578 18.0747 23 12 23C5.92526 23 1.00013 18.1578 1 12C1.00013 8.00609 3.34882 4.45292 6.5 2.63379Z" fill="#000" /><path d="M12 1C12.5523 1 13 1.44772 13 2V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V2C11 1.44772 11.4477 1 12 1Z" fill="#000" />
  </StyledIcon>
));

Power.displayName = 'Power';

export { Power };
